import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';

@Component({
  selector: 'ten-card-like',
  templateUrl: './card-like.component.html',
  styleUrls: ['./card-like.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SafeHtmlPipe],
})
export class CardLikeComponent {
  @Input() public svgHtml: string;
  @Input() public liked: boolean;
  @Output() public cardLiked = new EventEmitter<boolean>();

  public like() {
    this.liked = !this.liked;
    this.cardLiked.emit(this.liked);
  }
}
